module.exports = __webpack_public_path__ + "static/img/2.6f454b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2.png
// module id = UT21
// module chunks = 0